import { useGroupsForOrg } from "@coaching-culture/api-client";
import { GroupDto } from "@coaching-culture/types";
import {
  Button,
  Circle,
  Flex,
  Loader,
  Modal,
  Text,
} from "@coaching-culture/ui";
import { ItemContainer, ItemsList } from "components/ShareModal/Drawer";
import { useState } from "react";
import { FaUsers } from "react-icons/fa";

export type GroupSelectModalProps = {
  onSelect: (users: GroupDto[]) => void;
};

const Item = ({
  onClick,
  group,
  active,
}: {
  onClick: () => void;
  group: GroupDto;
  active: boolean;
}) => {
  return (
    <ItemContainer onClick={onClick}>
      <Flex width="400px" maxWidth="100%" alignItems="center">
        <Circle
          icon={FaUsers}
          color={active ? "primary" : "body"}
          mr={2}
          size="small"
        />
        <Text
          fontWeight={500}
          fontSize={4}
          color={active ? "positive" : "body"}
        >
          {group.name}
        </Text>
      </Flex>
    </ItemContainer>
  );
};

export function GroupSelectModal({ onSelect }: GroupSelectModalProps) {
  const [selected, setSelected] = useState<Record<string, boolean>>({});
  const groups = useGroupsForOrg();

  const toggle = (item: GroupDto) => {
    setSelected((old) => ({
      ...old,
      [item.id]: !old[item.id],
    }));
  };

  const confirm = () => {
    const g = (groups.data ?? []).filter((x) => selected[x.id]);
    onSelect(g);
  };

  return (
    <Modal
      width={600}
      minHeight={500}
      p={0}
      onClose={() => onSelect([])}
      showCloseButton
      style={{ overflow: "hidden" }}
    >
      <Flex alignItems="center" flexDirection="column" p={3}>
        <Circle color="primary" icon={FaUsers} size="large" mb={2} />
        <Text fontWeight={600} fontSize={6}>
          Select Groups
        </Text>
        <Text>
          {Object.values(selected).filter((x) => x).length} groups(s) selected.
        </Text>
      </Flex>
      {groups.data == null ? (
        <Loader />
      ) : (
        <ItemsList style={{ padding: 0 }}>
          {groups.data.map((x) => (
            <Item group={x} onClick={() => toggle(x)} active={selected[x.id]} />
          ))}
        </ItemsList>
      )}
      <Flex alignItems="center" justifyContent="center" p={3}>
        <Button onClick={confirm} color="primary" disabled={groups.isLoading}>
          Select
        </Button>
      </Flex>
    </Modal>
  );
}
